import React, { useEffect, useState } from 'react'
import {
  Box,
  Card,
  CardContent,
  InputAdornment,
  TextField,
  Typography,
  IconButton,
  Grid,
} from '@mui/material'
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded'
import SearchIcon from '@mui/icons-material/Search'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import { makeGetRequest } from 'utils/api'

function Catalogue() {
  const [lifeGroupeCat, setLifeGroupeCat] = useState([])
  const [lifeAppsCat, setLifeAppsCat] = useState([])
  // LAP-733 (GE022) — re-fetch on UI language change.
  const { i18n: i18nInstance } = useTranslation()

  useEffect(() => {
    const getLifeApps = async () => {
      const { data } = await makeGetRequest('/api/base/Lifeapps/', {}, true)

      let groupscat = []
      let groupsListcat = []
      for (let r of data) {
        if (groupscat.indexOf(r.Groupe) === -1) {
          groupscat.push(r.Groupe)
          groupsListcat.push({ nomgroupecat: r.Groupe })
        }
      }
      setLifeAppsCat(data)
      setLifeGroupeCat(groupsListcat)
    }
    getLifeApps()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18nInstance.language])

  const groupeName = lifeGroupeCat.map(
    (
      element,
      key, //         Menu déroulant de côté
    ) => (
      <Typography
        variant="h6"
        component="div"
        sx={{
          paddingTop: '5px',
          color: 'white',
        }}
      >
        {element.nomgroupecat}
      </Typography>
    ),
  )

  const appsname = (nomgroupecat) => {
    //         Construction apps
    return lifeAppsCat.map((element, key) =>
      nomgroupecat === element.Groupe ? (
        <Card
          key={key}
          sx={{
            margin: '5px',
            minWidth: 250,
            maxWidth: 250,
            backgroundImage: 'radial-gradient(rgb(0,29,110),rgb(0,12,34))',
            '& :hover': {
              cursor: 'pointer',
            },
          }}
        >
          <CardContent>
            <Typography variant="subtitle1" sx={{ paddingTop: '5px', color: 'white' }}>
              {element.Nom}
            </Typography>
          </CardContent>
          <Box
            sx={{
              position: 'relative',
              height: '80px',
            }}
          >
            <IconButton
              onClick={() => addItem(element)}
              sx={{ position: 'absolute', bottom: 0, right: 0 }}
            >
              <AddCircleOutlineRoundedIcon sx={{ color: 'white' }} />
            </IconButton>
          </Box>
        </Card>
      ) : null,
    )
  }

  let CatalogueGroup = lifeGroupeCat.map(
    (
      element,
      key, //         Groupe page catalogue
    ) => (
      <>
        <Typography
          variant="h5"
          key={key}
          sx={{
            textAlign: { xs: 'center', sm: 'left' },
            margin: '5px',
            color: 'white',
          }}
        >
          {element.nomgroupecat}
        </Typography>

        <Box display="flex" sx={{ justifyContent: { xs: 'center', sm: 'normal' } }} flexWrap="wrap">
          {appsname(element.nomgroupecat)}
        </Box>
      </>
    ),
  )

  const addItem = (element) => {
    let data = JSON.parse(JSON.stringify(element))
    data.display = true
    fetch('/api/base/Lifeapps/' + element.id + '/', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((res) => res.json())
  }
  return (
    <div style={{ minHeight: '100vh' }}>
      <Box p={1} bgcolor={'#001242'}>
        <Box p={1} borderRadius={'5px'} width="fit-content" bgcolor="#616161">
          <TextField
            id="filled-basic"
            label="Recherche"
            placeholder="Recherche"
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                // - The Input-root, inside the TextField-root
                '& fieldset': {
                  // - The <fieldset> inside the Input-root
                  borderColor: 'black', // - Set the Input border
                },
                '&:hover fieldset': {
                  borderColor: 'black', // - Set the Input border when parent has :hover
                },
                '&.Mui-focused fieldset': {
                  // - Set the Input border when parent is focused
                  borderColor: 'black',
                },
              },
              '& label.Mui-focused': {
                color: 'black',
              },
            }}
            // classes={classes.notchedOutline}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              // classes: {
              //   notchedOutline: classes.notchedOutline,
              // },
            }}
          />
        </Box>
      </Box>

      <Grid container>
        <Grid item md={3} xs={2}>
          {groupeName}
        </Grid>
        <Grid item md={9} xs={10}>
          {CatalogueGroup}
        </Grid>
      </Grid>
    </div>
  )
}

export default Catalogue
